export default "__VITE_ASSET__Bc4ILtdp__"